import { memo, ReactNode } from 'react';
import { TableProps } from '../..';
import { Flex } from '@chakra-ui/react';
import * as Styles from '../../styles';

interface BodyProps {
  rows: TableProps['rows'];
  sizes: string;
  row: TableProps['row'];
  path?: string | undefined;
  locations?: string[];
  handles: any[];
  buttons: ReactNode[];
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const BodyComponent: React.FC<BodyProps> = ({ rows, sizes, row, path, handles, buttons }) => {
  const routeDemandsSAndParms = `${'/filedDemands'}?page=0`;
  const query = location.search;
  return (
    <Styles.TableBody>
      {rows.map((tr, trIndex) => (
        <Flex key={trIndex} align={'center'} marginBottom={'10px'} cursor={'pointer'}>
          <Styles.Tr
            sizes={sizes}
            key={`tr-${trIndex}`}
            onClick={() => {
              routeDemandsSAndParms.includes('/demands') &&
                localStorage.setItem('queryPageDemands', query.slice(6));
            }}
          >
            {tr.map((td, tdIndex) => (
              <Styles.Td key={`td-${tdIndex}`} onClick={handles[trIndex]}>
                {td || '-'}
              </Styles.Td>
            ))}
            <Styles.Td key={`td-${trIndex}`}>{buttons[trIndex]}</Styles.Td>
          </Styles.Tr>
        </Flex>
      ))}
    </Styles.TableBody>
  );
};

export const Body = memo(BodyComponent);
